import savedSearchTemplate from './savedSearch.html';
import savedSearchController from './savedSearch.controller';

function directive() {
  return {
    restrict: 'E',
    scope: {
      filterSet: '='
    },
    template: savedSearchTemplate,
    controller: 'savedSearchController'
  };
}

export default function (ngModule) {
  ngModule.directive('savedSearch', directive);
  savedSearchController(ngModule);
}
